<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field class="content" appearance="outline">
        <mat-label>Scan Barcode</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput #message maxlength="256" placeholder="Ex. I need help with..." formControlName="scanId" appAutofocus autocomplete="off" data-test-id="scanInput">

    </mat-form-field>
</form>
